import React, { Component } from 'react';
import PropTypes from 'prop-types';


import LocationOn from '@mui/icons-material/LocationOn';
import LocationOff from '@mui/icons-material/LocationOff';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
//import Button from '@mui/material/Button';
//import Input from '@mui/material/Input';
import Popper from '@mui/material/Popper';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
//import FileUploadIcon from '@mui/icons-material/CloudUpload';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import { Box, Button, InputAdornment } from '@mui/material';
import 'leaflet/dist/leaflet.css';
//import { Autocomplete } from '@mui/material';
//import MapPreview from '../map/MapPreview';

//absolute left:27
const s:any = {
  container: {
    display: 'flex',
    justifyContent:'flex-start',
    alignItems: 'center'
  },
  MuiCardContentRoot:{
    margin: 'spacing(1)',
    height:'85%'
  },
  preview: {
    width:300,
    height: 40,
    marginTop: 'spacing(1)',
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
  },
  cardroot:{
    width: '100%',
    height: '100%',
    margin: 0
  },
  popper:{
    marginTop: 'spacing(12)',
    marginLeft: 'spacing(20)',
    width: '80%',
    height: '80%',
    zIndex: 1300
  },

  mapbox:{
    width: '100%',
    height: '100%',
    // margin: theme.spacing(1)
  },
  button: {
    m: 1,
  },
  input: {
    display: 'none',
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'flex'
  }
};

class FGeoLocation extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any = {position:[7.9465,-1.0232],zoom:6,info:'Drag to prefferred location'};
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      id: undefined,
      anchor: undefined,
      source: undefined,
      blank: false,
      value: this.props.value||'',
      valid: true
    };
  }

  onMouseDown = (event:any) => {
    event.preventDefault();
  };

  handleChange = (event:any) => {
    const {onChange} = this.props;
    let value = event.target.value;
    if(value===undefined) {
      const {lat,lng} = event.target._latlng;
      value = `(${lat}, ${lng})`;
      this.setState({valid:false});
    }
    if(typeof onChange === 'function') onChange(value);
    this.setState({value});
  };

  handlePopper = (event:any) => {
    // console.log('target.parent',event.currentTarget.parent);
    this.setState({id:'map-popper',open:!this.state.open,anchor:event.currentTarget})
  }

  render() {
    const {name,label,required,divider,classes} = this.props;
    const {position,zoom,info} = this.props;
    const {id,anchor,open,geocoord,valid} = this.state;
    const blank = !(typeof geocoord === 'object'  && geocoord.x && geocoord.y);
    const height = 250;
    const defaultPosition: [number, number] = [7.9465, -1.0232];
    const safePosition = position != null && (Array.isArray(position) ? position.length >= 2 : (typeof (position as any)?.lat === 'number' && typeof (position as any)?.lng === 'number'))
      ? position
      : defaultPosition;
    // console.log('mapprops:',position,zoom,info);
    // console.log('popperprops:',open,anchor,geocoord);
    return (
      <Box sx={{...s.root}}>
        <TextField
          label={label}
          name={name}
          fullWidth={true}
          margin='normal'
          helperText={'Enter your location here eg: (x,y)'}
          onChange={this.handleChange}
          value={this.state.value}
          required={required}
          sx={{...s.textField}}          
          InputProps={{
            endAdornment: 
              <InputAdornment position={"end"}>
                <IconButton
                  onClick={this.handlePopper}
                  onMouseDown={this.onMouseDown}
                >
                  {blank ? <LocationOff /> : <LocationOn />}
                </IconButton>
              </InputAdornment>
          }}
        />
        <Popper id={id} open={open} anchorEl={null} transition sx={{...s.popper}}
          placement="top"
          disablePortal={true}
          modifiers={[
            {name:'flip',enabled: true},
            {name:'preventOverflow',
             enabled: true,//
             //boundariesElement: 'scrollParent',
            },
            { name: 'arrow',
              enabled: false,
            },
          ]}
        >
          {/* {({ TransitionProps }) => (
            <Fade {...TransitionProps}  timeout={350}> */}
              <Card sx={{...s.cardroot}} variant="outlined">
                <CardContent sx={{...s.MuiCardContentRoot}}>
                  <MapContainer center={safePosition} zoom={zoom||13} scrollWheelZoom={false} style={{...s.mapbox}} >
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                    />
                    <Marker position={safePosition} draggable={true} eventHandlers={{
                      dragend: this.handleChange
                    }}>
                      <Popup>{info}</Popup>
                    </Marker>
                  </MapContainer>  
                </CardContent>
                <CardActions>
                  <Button size="small" onClick={this.handlePopper}>Close</Button>
                  <Button size="small" disabled={valid}  onClick={this.handlePopper}>Select</Button>
                </CardActions>
              </Card>
              
            {/* </Fade>
          )} */}
        </Popper>

        {divider && <Divider />}
      </Box>
    );
  }
}

FGeoLocation.propTypes = {
  classes: PropTypes.object.isRequired,
  //children: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
};

export default FGeoLocation;
